// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"530":"a2cfb184","787":"f3deff5b"}[chunkId] + ".chunk.js";
};